// Pilot usage analytics — product telemetry for the APP OWNER, not school staff.
//
// Deliberately separate from the FERPA audit trail (auditLogs): audit logs
// answer "who touched which student" and are visible to school super-admins;
// usage events answer "which features get used" and are readable ONLY by the
// owner allow-list below. Events never carry student identifiers (enforced by
// the prop sanitizer in utils/usageAnalytics.js and by firestore.rules).
//
// The email list is mirrored in firestore.rules (isUsageAnalyticsOwner) —
// rules cannot import app code, so keep the two in sync when you change it.

export const ANALYTICS_OWNER_EMAILS = [
  'ryan@casemanagevue.com',
  'admin@casemanagevue.com',
  'rypdavis@gmail.com',
  'casemanagevue@gmail.com'
  // Add your real sign-in email(s) here — and in firestore.rules — before
  // deploying to a production district project. UIDs differ per Firebase
  // project; emails do not, which is why the gate is email-based.
]

export function isUsageAnalyticsOwner(user) {
  const email = user?.email?.toLowerCase()
  if (!email) return false
  return ANALYTICS_OWNER_EMAILS.some((e) => e.toLowerCase() === email)
}

// Canonical event names. Feature events use event='feature' + feature=<key>;
// keeping `event` to a small closed set makes the rules validation meaningful.
export const USAGE_EVENTS = {
  SESSION_START: 'session_start',
  PAGE_VIEW: 'page_view',
  FEATURE: 'feature'
}

// Feature keys (the `feature` field on event='feature' docs).
export const USAGE_FEATURES = {
  STUDENT_SAVE: 'student_save',
  STUDENT_DELETE: 'student_delete',
  MEETING_SAVE: 'meeting_save',
  SCHEDULE_IMPORT: 'schedule_import',
  PDF_GENERATED: 'pdf_generated',
  DATA_EXPORT: 'data_export',
  FEEDBACK_SUBMITTED: 'feedback_submitted'
}
